<template>
    <div id="app">
        <keep-alive :include="includePage">
            <router-view></router-view>
        </keep-alive>
        <!-- <promotionOnlinePopUp :visible="isShowOnlinePop && !isShowOnlinePopOnce"></promotionOnlinePopUp> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['includePage', 'isShowPromotion21Pop', 'isShowLdx21Pop', 'isShowEntry', 'popupShow','isShowOnlinePop','isShowOnlinePopOnce']),
        isExpire() {
            let timestamp = Date.parse(new Date());
            // 1617206399  2021-03-31 23.59.59
            if (timestamp > 1617206399000) {
                return false;
            }
            return true;
        }
    },
    name: 'App',
    data() {
        return {};
    },
    components: {
        
    },
    created(){
    },
    methods: {},
    mounted() {
        const token = !!this.$store.getters.token;
        if (token) {
            // this.$store.dispatch('getletterinfo');
        }
    }
};
</script>

<style lang="scss">
html,
body,
#app {
    width: 100%;
    height: 100%;
}
.router-view-c {
    position: absolute;
    transition: opacity 0.5s, transform 0.5s;
    width: 100%;
    height: 100%;
}
.router-fade-enter-active,
.router-fade-leave-active {
    transition: opacity 0.3s;
}
.router-fade-enter,
.router-fade-leave-active {
    opacity: 0;
}
.passport-toast {
    width: auto;
    padding: 35px 50px 33px;
    min-height: auto;
    border-radius: 15px;
    i {
        font-size: 40px;
    }
    div {
        margin-top: 25px;
        font-size: 26px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        max-width: 282px;
    }
}
.van-cell::after {
    border: none;
}

.class-type1 {
    background-image: linear-gradient(to left, #ffa847, #ff7d3d);
}
.class-type2 {
    background-image: linear-gradient(to left, #fe774a, #fc4646);
}
.class-type3 {
    background-image: linear-gradient(to left, #50b3ec, #3d95f5);
}
</style>
